/* tslint:disable */

import { Action } from '@ngrx/store';
import { IMadlibOptions } from '../../shared/services/mad-lib-services/mad-lib-helpers';
export const LOAD_MADLIB_OPTIONS = '[Portal] Load Madlib Options';
export const LOAD_MADLIB_OPTIONS_SUCCESS = '[Portal] Load Madlib Options Success';
export const LOAD_MADLIB_OPTIONS_FAIL = '[Portal] Load Madlib Options Failure';

// register store actions
export class LoadMadlibOptions implements Action {
  readonly type = LOAD_MADLIB_OPTIONS;
  constructor(public payload: any) {}
}

export class LoadMadlibOptionsSuccess implements Action {
  readonly type = LOAD_MADLIB_OPTIONS_SUCCESS;
  constructor(public payload: IMadlibOptions) {}
}

export class LoadMadlibOptionsFail implements Action {
  readonly type = LOAD_MADLIB_OPTIONS_FAIL;
  constructor(public payload: any) {}
}

// action types
export type MadlibOptionsAction = LoadMadlibOptions | LoadMadlibOptionsFail | LoadMadlibOptionsSuccess;
